import React from 'react';
import withAppState from '../../../mobx/withAppState'
import { Steps } from '../../../lib/constants';
import Bill from '../../../components/Bill';

const MiPayAtTableBillWrapper = (props) => {
  const handleNoBill = () => {
    props.popStep();
  }
  
  const handleApplyVoucherButton = () => {
    props.goToStep(Steps.APPLY_VOUCHER);
  }

  const handleJoinSplitButton = () => {
    props.goToStep(Steps.SPLIT_BILL_NAME);
  }

  
  return (
    <Bill
      handleNoBill={handleNoBill}
      handleApplyVoucherButton={handleApplyVoucherButton}
      handleJoinSplitButton={handleJoinSplitButton}
      currency={props.getCurrency()}
    />
  )
}

export default withAppState(MiPayAtTableBillWrapper,
  {
    mobXActions: ({
      popStep,
      goToStep,
      getCurrency
    }) => ({
      popStep,
      goToStep,
      getCurrency
    })
  }
);